import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listCompanies, type Company } from "../../services/companies-api";

/** FR-042: the CO Member's entry point into any company's dashboard — pick a company, then land
 * on `/co-member/dashboard/:companyId` (CompanyDashboardPage). */
export function DashboardCompanyPickerPage() {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState<Company[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    listCompanies().then(setCompanies);
  }, []);

  return (
    <div className="p-6">
      <h1 className="mb-4 font-sans text-xl text-ink">{t("dashboard.title", "Report")}</h1>
      <p className="mb-4 text-sm text-body">Pick a company to view its results dashboard.</p>
      <ul className="flex flex-col gap-1">
        {companies.map((c) => (
          <li key={c.id}>
            <button
              onClick={() => navigate(`/co-member/dashboard/${c.id}`)}
              className="w-full rounded px-3 py-2 text-left text-sm text-ink hover:bg-surface-alt"
            >
              {c.name}
            </button>
          </li>
        ))}
        {companies.length === 0 && <p className="text-sm text-body">No companies onboarded yet.</p>}
      </ul>
    </div>
  );
}
